import React, { useContext } from 'react';
import proptypes from 'prop-types';
import classNames from 'classnames';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { DragHandleContainer } from './DragHandleContainer';
import { GroupAccordionContext } from '../GroupAccordionContext';
import { GroupItemAlert } from './GroupItemAlert';

const { string, func, number, shape, oneOfType, node } = proptypes;

const GroupItem = ({
  renderPod, id, item, itemRef, numbering, groupId, alert, index, renderDeleteButton
}) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const {
    selectedItems, disableSelection, disableDragAndDrop, onUnselectItem, onSelectItem, showHorizontalDragHandleContainer
  } = useContext(GroupAccordionContext);
  const isChecked = selectedItems[groupId]?.items?.includes(item);

  const onCheckCheck = () => {
    if (isChecked) {
      onUnselectItem(item, groupId);
    } else {
      onSelectItem(item, groupId);
    }
  };

  const itemWrapperClass = classNames(
    'sui-flex sui-flex-col sui-border-primary sui-border-solid sui-pb-3',
    {
      'sui-pt-1': showHorizontalDragHandleContainer,
      'sui-pt-3': !showHorizontalDragHandleContainer,
      'sui-border-y-1': index === 0 && !isMobile,
      'sui-border-b-1': index > 0 && !isMobile,
      'sui-border-1': isMobile
    }
  );

  const dragHandleContainerWrapperClass = classNames('sui-w-full', {
    'sui-flex': !showHorizontalDragHandleContainer
  });

  const alertWrapperClass = classNames({
    'sui-px-3': showHorizontalDragHandleContainer,
    'sui-py-3': showHorizontalDragHandleContainer,
    'sui-pb-4': !showHorizontalDragHandleContainer
  });

  return (
    <div
      className={itemWrapperClass}
      data-testid={`item-wrapper-${item}`}
      style={{
        minHeight: '64px',
      }}
    >
      {alert && (
        <div className={alertWrapperClass}>
          <GroupItemAlert alert={alert} />
        </div>
      )}
      <div className={dragHandleContainerWrapperClass}>
        <DragHandleContainer
          id={id}
          itemRef={itemRef}
          onCheck={onCheckCheck}
          checked={isChecked}
          numbering={numbering}
          disableSelection={disableSelection}
          disableDragAndDrop={disableDragAndDrop}
          showHorizontalDragHandleContainer={showHorizontalDragHandleContainer}
          renderDeleteButton={renderDeleteButton}
        />
        {renderPod({ id: item, groupId })}
      </div>
    </div>
  );
};

GroupItem.propTypes = {
  renderPod: func.isRequired,
  id: string.isRequired,
  item: string.isRequired,
  itemRef: func,
  numbering: number,
  groupId: string.isRequired,
  alert: oneOfType([
    shape({
      status: string.isRequired,
      render: func,
    }),
    node,
  ]),
  index: number,
  renderDeleteButton: func
};

GroupItem.defaultProps = {
  itemRef: null,
  numbering: null,
  alert: null,
  index: 0,
  renderDeleteButton: () => {}
};

GroupItem.displayName = 'GroupItem';

export { GroupItem };
